import React, { useEffect, useState } from "react";
import axios from "axios";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";

const MasterOldBill = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Search & Pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    fetchOldMasterBill();
  }, []);

  const fetchOldMasterBill = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      const society = localStorage.getItem("society");

      const response = await axios.post(
        `${BASE_URL}/bill-master/get-old-master-bill`,
        null,
        {
          params: {
            societyName: society,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setBillData(response.data || []);
    } catch (error) {
      console.error(
        "Error fetching old master bill:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  // Search Filter
  const filteredData = billData.filter((row) =>
    Object.values(row).some((value) =>
      String(value || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );

  // Pagination
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const formatColumnName = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="app-container min-h-screen bg-gray-100">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout flex">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area flex-1">
          <SubHeader />

          <div className="p-4 md:p-6">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200">
              
              {/* Header */}
              <div className="border-b border-gray-200 p-5">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                  <div className="flex flex-col sm:flex-row gap-3">
                    <input
                      type="text"
                      placeholder="🔍 Search records..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                      className="border border-gray-300 rounded-xl px-4 py-2 w-full sm:w-72 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />

                    <button
                      onClick={fetchOldMasterBill}
                      className="bg-blue-600 text-white px-5 py-2 rounded-xl hover:bg-blue-700 transition"
                    >
                      Refresh
                    </button>
                  </div>
                </div>
              </div>
              {loading ? (
                <div className="flex justify-center items-center py-16">
                  <div className="h-12 w-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                </div>
              ) : (
                <>
                  <div className="overflow-x-auto">
                    <table className="min-w-full">
                      <thead>
                        <tr className="bg-blue-600 text-white">
                          {billData.length > 0 ? (
                            Object.keys(billData[0]).map((key) => (
                              <th
                                key={key}
                                className="px-4 py-3 text-left text-sm font-semibold whitespace-nowrap"
                              >
                                {formatColumnName(key)}
                              </th>
                            ))
                          ) : (
                            <th className="px-4 py-3">No Data</th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {currentRows.length > 0 ? (
                          currentRows.map((row, index) => (
                            <tr
                              key={index}
                              className={`border-b hover:bg-blue-50 transition ${
                                index % 2 === 0
                                  ? "bg-white"
                                  : "bg-gray-50"
                              }`}
                            >
                              {Object.values(row).map((value, i) => (
                                <td
                                  key={i}
                                  className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap"
                                >
                                  {value !== null &&
                                  value !== undefined &&
                                  value !== ""
                                    ? String(value)
                                    : "-"}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                billData.length > 0
                                  ? Object.keys(billData[0]).length
                                  : 1
                              }
                              className="text-center py-10 text-gray-500"
                            >
                              No records found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {totalPages > 1 && (
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-5 border-t border-gray-200">
                      <div className="text-sm text-gray-600">
                        Page{" "}
                        <span className="font-semibold">
                          {currentPage}
                        </span>{" "}
                        of{" "}
                        <span className="font-semibold">
                          {totalPages}
                        </span>
                      </div>

                      <div className="flex gap-2">
                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.max(prev - 1, 1)
                            )
                          }
                          disabled={currentPage === 1}
                          className="px-4 py-2 border rounded-lg disabled:opacity-50 hover:bg-gray-100"
                        >
                          Previous
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          disabled={currentPage === totalPages}
                          className="px-4 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-50 hover:bg-blue-700"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MasterOldBill;